import ReactGA from 'react-ga4';

const GA_MEASUREMENT_ID = 'G-9SDY5QDWR7';

let isInitialized = false;
const pendingPageviews: string[] = [];

// gtag.js is ~157 KB and eats ~150 ms of main-thread time, so it must not
// compete with the app bundle during startup - index.tsx calls
// initAnalytics() only after the window load event. Pageviews fired before
// that are buffered here and flushed on init; pushing them straight to the
// dataLayer would lose them, because gtag drops events that arrive before
// its config command.
export const trackPageview = (page: string) => {
  if (!isInitialized) {
    pendingPageviews.push(page);
    return;
  }

  ReactGA.send({ hitType: 'pageview', page });
};

export const initAnalytics = () => {
  if (isInitialized) {
    return;
  }

  ReactGA.initialize(GA_MEASUREMENT_ID, {
    gaOptions: {
      send_page_view: false,
    },
  });
  isInitialized = true;

  while (pendingPageviews.length) {
    const page = pendingPageviews.shift();

    if (page) {
      ReactGA.send({ hitType: 'pageview', page });
    }
  }
};
